/** Jarvis Knowledge — shared helpers + pack list. */
import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { btnPrimary, errorText, inputCls } from '../finance/financeUi';

export const ROLES = [['iso', 'ISOs'], ['iso_agent', 'Agents'], ['iso_subagent', 'Subagents'], ['affiliate', 'Affiliates']];

export async function upload(path, file, extra = {}) {
  const fd = new FormData();
  fd.append('file', file);
  Object.entries(extra).forEach(([k, v]) => fd.append(k, v));
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, { method: 'POST', body: fd, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : `Upload failed (${res.status})`);
  return data;
}

export function PackList({ packs, selected, onSelect, onCreated }) {
  const [name, setName] = useState('');
  const create = async () => {
    try { const p = await api.request('/jarvis/packs', { method: 'POST', body: JSON.stringify({ name }) }); setName(''); onCreated(p); toast.success('Pack created'); } catch (e) { toast.error(errorText(e)); }
  };
  return (
    <div className="space-y-3" data-testid="jarvis-pack-list">
      <ul className="divide-y rounded-xl border bg-card">
        {packs.map((p) => (
          <li key={p.pack_id}>
            <button type="button" onClick={() => onSelect(p.pack_id)} data-testid={`jarvis-pack-${p.pack_id}`}
                    className={`flex w-full items-center justify-between px-4 py-2.5 text-left text-sm transition-colors hover:bg-muted/50 ${selected === p.pack_id ? 'bg-muted/70 font-semibold' : ''}`}>
              <span className={p.enabled ? '' : 'text-muted-foreground line-through'}>{p.name}</span>
              <span className="text-xs text-muted-foreground">{p.source_count}</span>
            </button>
          </li>
        ))}
      </ul>
      <div className="flex gap-2">
        <input className={inputCls} placeholder="New pack name" value={name} onChange={(e) => setName(e.target.value)} data-testid="jarvis-new-pack-name" />
        <button type="button" className={btnPrimary} disabled={!name.trim()} onClick={create} data-testid="jarvis-new-pack-btn">Add</button>
      </div>
    </div>
  );
}
